import axios from "axios";
import axiosRetry from "axios-retry/dist/cjs";
import { MAIN_API } from "../config/stepoutAPI";

const apiClient = axios.create({
  baseURL: MAIN_API,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

axiosRetry(apiClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) =>
    axiosRetry.isNetworkOrIdempotentRequestError(error) ||
    error.response.status === 429,
});

export default apiClient;
